const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Network Budget Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});